// A qué página/registro lleva cada tipo de acción de una alerta. Lo comparten el panel principal y el chip de alertas
// que aparece en el resto de los encabezados.
export const ALERT_ROUTES = {
  'start-renewal': (p) => ({ path: '/Contratos', query: { contractId: p.contractId, actionType: 'start-renewal' } }),
  'manage-renewal': (p) => ({ path: '/Contratos', query: { contractId: p.contractId, actionType: 'manage-renewal' } }),
  'apply-escalation': (p) => ({ path: '/Contratos', query: { contractId: p.contractId, actionType: 'apply-escalation' } }),
  'view-tenant-detail': (p) => ({ path: '/Contratos', query: { contractId: p.contractId, actionType: 'view-tenant-detail' } }),
  'view-finance': () => ({ path: '/Finanzas' }),
  'view-ticket': (p) => ({ path: '/Mantenimiento', query: { ticketId: p.ticketId } }),
  'view-services': (p) => ({
    path: '/Servicios',
    query: p.periodYear && p.periodMonth ? { period: `${p.periodYear}-${String(p.periodMonth).padStart(2, '0')}` } : {},
  }),
}